export default __webpack_public_path__ + "static/media/yoga-position.b3441b15.svg";